export enum ToggleActionType {
  OPEN = "open",
  CLOSE = "close",
}
